import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'g[sa-lmo-current-stock-graph-truck]', // tslint:disable-line
  template: `
    <svg *ngIf="isActive" width="34" height="24" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g>
        <path
          d="M0.724111 0H10.1544C10.3634 0 10.5462 0.178723 10.5462 0.382979V1.99149H14.2295C15.1961 1.99149 16.0059 2.75745 16.0059 3.72766V9.62553C16.0059 9.98298 15.6924 10.2894 15.3267 10.2894H14.8565C14.6736 11.2596 13.8116 12 12.7667 12C11.7217 12 10.8597 11.2596 10.6768 10.2894H6.39273C6.20987 11.2596 5.34782 12 4.30291 12C3.25801 12 2.39596 11.2596 2.2131 10.2894H0.697989C0.489008 10.2894 0.306149 10.1106 0.306149 9.90638V0.382979C0.332272 0.178723 0.51513 0 0.724111 0Z"
          fill="#1F7A8C"
        />
      </g>
      <text font-size="8" text-anchor="middle" x="7" y="9" fill="white">+{{ truckCount }}</text>
    </svg>
    <svg *ngIf="!isActive" width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <svg:g>
        <svg:path
          d="M0.724111 0H10.1544C10.3634 0 10.5462 0.178723 10.5462 0.382979V1.99149H14.2295C15.1961 1.99149 16.0059 2.75745 16.0059 3.72766V9.62553C16.0059 9.98298 15.6924 10.2894 15.3267 10.2894H14.8565C14.6736 11.2596 13.8116 12 12.7667 12C11.7217 12 10.8597 11.2596 10.6768 10.2894H6.39273C6.20987 11.2596 5.34782 12 4.30291 12C3.25801 12 2.39596 11.2596 2.2131 10.2894H0.697989C0.489008 10.2894 0.306149 10.1106 0.306149 9.90638V0.382979C0.332272 0.178723 0.51513 0 0.724111 0Z"
          fill="#1F7A8C"
        />
      </svg:g>
    </svg>
  `,
})
export class LmoCurrentStockGraphTruckSvgComponent {
  @Input() public truckCount: number;
  @Input() public isActive: boolean;

  public fill = '#4d94ff';
  public opacity = 1;
}
